import { View } from 'backbone.marionette';
import './index.styl';
import { Model } from "backbone";
import template from "./index.jst";

export class MatchCentreGameBarRounds extends View {
	get className() {
		return 'match-centre-game-bar-rounds js-rounds'
	}
	get template() {
		return template;
	}

	initialize() {
		this.model = new Model({
			rounds: [],
			selected: 0,
			image_squads_path: process.env.SQUAD_LOGOS_PATH,
		});
		this.collection.reset();
	}

	init({ rounds, selected }) {
		this.model.set({ rounds, selected });
		this.collection.reset(rounds);
		this.render();
	}
}

export default MatchCentreGameBarRounds;